'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var expression = /((?:(?:http(?:s|):\/\/)|(?:www\.))(?:[^,\s])+[^(?:\s\].,)])/gi;
var isCorrectUrl = function (string) {
    var urlRegExp = new RegExp(expression);
    return urlRegExp.test(string);
};

var getRelationshipAttribute = function (url) {
    if (/^https?:\/\/www.videos-vno.com\/?/.test(url)) {
        return 'noopener';
    }
    return 'noreferrer noopener';
};
var TextWithLinks = function (_a) {
    var text = _a.text, viewDetailText = _a.viewDetailText;
    var urlRegExp = new RegExp(expression);
    return (React__default.createElement(React__default.Fragment, null, text === null || text === void 0 ? void 0 : text.split(urlRegExp).map(function (part) {
        if (isCorrectUrl(part)) {
            return (
            // eslint-disable-next-line react/jsx-no-target-blank
            React__default.createElement("a", { href: part, target: "_blank", rel: getRelationshipAttribute(part), key: part }, viewDetailText));
        }
        return part;
    })));
};

exports.TextWithLinks = TextWithLinks;
exports.getRelationshipAttribute = getRelationshipAttribute;
